
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"35","viewBox":"0 0 57 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.05 9.518H22.382v20.965h11.666V9.518z","fill":"#FF5F00"}}),_c('path',{attrs:{"d":"M23.12 20a13.31 13.31 0 015.093-10.483 13.333 13.333 0 100 20.966A13.31 13.31 0 0123.121 20z","fill":"#EB001B"}}),_c('path',{attrs:{"d":"M49.788 20a13.333 13.333 0 01-21.572 10.483 13.334 13.334 0 000-20.966A13.333 13.333 0 0149.788 20zM48.51 28.265v-.43h.173v-.087h-.44v.087h.172v.43h.095zm.856 0v-.518h-.136l-.155.356-.155-.356h-.136v.518h.096v-.39l.146.336h.099l.145-.337v.39h.096z","fill":"#F79E1B"}})])
          )
        }
      }
    